import React from "react";
import styles from "./VpnTypes.module.css";
const Wireguard = ({ onMainPage, item }) => {
  return (
    <div className={styles.vpnType}>
      {item?.contain?.online && <div className={styles.isOnline}></div>}
      <img src="/asets/Wiregaurd.svg" width={30} />
      Wireguard
    </div>
  );
};

export default Wireguard;
